/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ContactFilterFromJSON, ContactFilterToJSON } from './ContactFilter';
export function GetContactFilterResponseDataFromJSON(json) {
    return GetContactFilterResponseDataFromJSONTyped(json, false);
}
export function GetContactFilterResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        filter: !exists(json, 'filter') ? undefined : ContactFilterFromJSON(json['filter'])
    };
}
export function GetContactFilterResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        filter: ContactFilterToJSON(value.filter)
    };
}
